<template>
  <div id="app">
    <!-- <transition :name="transitionName"> -->
    <vue-page-stack>
      <router-view
        :key="$route.fullPath"
        class="router-view-c"
        @pageHomeLoadComplet="pageHomeLoadComplet"
      ></router-view>
    </vue-page-stack>
    <!-- </transition> -->
    <div class="ai_service" v-show="pathName!='helpSmart'&&loadComplet" 
      ref="ball"
      :style="{ left: `${x}px`, top:`${y}px` }"
      @touchstart="handleTouchStart"
      @touchmove="handleTouchMove"
      @touchend="handleTouchEnd"

    >
      <span class="iconfont iconaikefu ai_service_icon"></span>
    </div>
    <!-- 带看录音 -->
    <div
      class="ai-interview-recording"
      v-show="
        pathName != 'analyseAudioAgent' &&
        loadComplet &&isRecording"
      id="aiAudioIcon"
      ref="audioIcon"
      :style="{ left: `${audioX}px`, top: `${audioY}px` }"
      @touchstart="handleTouchAudioStart"
      @touchmove="handleTouchAudioMove"
      @touchend="handleTouchAudioEnd"
    >
      <span class="iconfont icongantanhao-yuankuang"></span>
    </div>
  </div>
</template>

<script>
import { Dialog, Toast } from "vant";
export default {
  metaInfo: {
    meta: [
      { charset: "utf-8" },
      // { name: "referrer", content: "no-referrer" },
      // { name: 'referrer', content: 'http://www.mfzcw.com/' }
    ],
  },
  name: "App",
  data() {
    return {
      transitionName: "forward",
      pathName: "",
      loadComplet: false,

      x: -13, //window.innerWidth - 27, // 初始位置（屏幕右侧）
      y: 500,
      startX: 0,
      startY: 0,
      isDragging: false,
      audioX: window.innerWidth - 81, // 初始位置（屏幕右侧）
      audioY: 600,
      startAudioX: 0,
      startAudioY: 0,
      isRecording: false,
    };
  },
  created() {
    // this.getProjectInfo();
    // this.getLoginInfo();

    document.getElementsByTagName("html")[0].style.fontSize =
      (window.innerWidth / 375) * 16 + "px";
    commonObj.getUserInfo().nickName = commonObj.getUserInfo().nickName;
    this.setAllAlert();
  },
  watch: {
    $route(to, from) {
      if (to.params["stack-key-dir"] === "forward") {
        this.transitionName = "forward";
      } else {
        this.transitionName = "back";
      }
      this.pathName = to.name;
       // 每次页面切换时检查localStorage中的录音状态
    if(localStorage.getItem("localAudioStute")=="1"){
      this.isRecording = true;
    } else {
      this.isRecording = false;
    }
    },
  },
  methods: {
    dialogAlert(msg) {
      Dialog.confirm({
        title: "温馨提示",
        message: msg,
        showCancelButton: false,
      })
        .then(() => {})
        .catch(() => {});
    },
    setAllAlert() {
      let that = this;
      SXApi.call(
        function (suc) {
          try {
            let temp = JSON.parse(suc.data);
            if (temp.router && temp.router == "visit") {
              that.dialogAlert(temp.content);
            }
          } catch (error) {}
        },
        null,
        "FunctionPlugin",
        "aliasName",
        {
          userId: commonObj.getUserInfo().staffId,
        }
      );
    },
    //获取项目信息
    getProjectInfo() {
      SXApi.call(
        function (suc) {
          if (suc.data && suc.data.data) {
            localStorage.setItem("thisProjectInfo", suc.data.data);
          }
        },
        null,
        "FunctionPlugin",
        "get_location",
        {
          key: "thisProjectInfo",
        }
      );
    },
    //获取登录信息
    getLoginInfo() {
      let that = this;
      SXApi.call(
        function (suc) {
          if (suc.data && suc.data.data) {
            var userInfo1 = JSON.parse(suc.data.data);
            let obj = { userInfo: userInfo1 };
            that.$store.commit("stateFn", obj);
          }
        },
        null,
        "FunctionPlugin",
        "get_location",
        {
          key: "userInfo",
        }
      );
    },

    handleTouchStart(e) {
      this.isClick = true;
      this.isDragging = true;
      this.startX = e.touches[0].clientX - this.x;
      this.startY = e.touches[0].clientY - this.y;
      this.touchStarX = e.touches[0].clientX;
      this.touchStarY = e.touches[0].clientY;
      e.preventDefault(); // 防止页面滚动
    },

    handleTouchMove(e) {
      if (!this.isDragging) return;
      //this.isClick=false;
      const touch = e.touches[0];
      this.x = touch.clientX - this.startX;
      this.y = touch.clientY - this.startY;
      //console.log(Math.abs(e.touches[0].clientX-this.touchStarX))
      //console.log("y"+this.y)
      if (
        Math.abs(e.touches[0].clientX - this.touchStarX) > 3 ||
        Math.abs(e.touches[0].clientY - this.touchStarY) > 3
      ) {
        this.isClick = false;
      }

      // 限制在屏幕内
      this.x = Math.max(0, Math.min(this.x, window.innerWidth - 40));
      this.y = Math.max(0, Math.min(this.y, window.innerHeight - 40));

      e.preventDefault(); // 阻止默认行为
    },

    handleTouchEnd() {
      this.isDragging = false;
      if (this.isClick) {
        this.goHelpSmart();
      }
      this.endRemove();
    },

    handleResize() {
      // 窗口大小变化时重新计算位置
      this.x = Math.max(0, Math.min(this.x, window.innerWidth - 40));
      this.y = Math.max(0, Math.min(this.y, window.innerHeight - 40));
    },
    pageHomeLoadComplet() {
      this.loadComplet = true;
      window.addEventListener("resize", this.handleResize);
    },
    goHelpSmart() {
      try {
        commonObj.addScrollTop();
      } catch (error) {}
      this.tourl("helpSmart");
    },
    endRemove() {
      try {
        if (
          parseInt(this.$refs.ball.style.left) > window.innerWidth - 42 &&
          parseInt(this.$refs.ball.style.left) < window.innerWidth - 29
        ) {
          this.$refs.ball.style.left = window.innerWidth - 27 + "px";
        }
        if (
          parseInt(this.$refs.ball.style.left) < 2 &&
          parseInt(this.$refs.ball.style.left) > -15
        ) {
          this.$refs.ball.style.left = "-13px";
        }
      } catch (error) {}
    },
    handleTouchAudioStart(e) {
      this.isClick = true;
      this.isDraggingAudio = true;
      this.startAudioX = e.touches[0].clientX - this.audioX;
      this.startAudioY = e.touches[0].clientY - this.audioY;
      this.touchAudioStarX = e.touches[0].clientX;
      this.touchAudioStarY = e.touches[0].clientY;
      e.preventDefault(); // 防止页面滚动
    },

    handleTouchAudioMove(e) {
      if (!this.isDraggingAudio) return;
      //this.isClick=false;
      const touch = e.touches[0];
      this.audioX = touch.clientX - this.startAudioX;
      this.audioY = touch.clientY - this.startAudioY;
      if (
        Math.abs(e.touches[0].clientX - this.touchAudioStarX) > 3 ||
        Math.abs(e.touches[0].clientY - this.touchAudioStarY) > 3
      ) {
        this.isClick = false;
      }
      // 限制在屏幕内
      this.audioX = Math.max(0, Math.min(this.audioX, window.innerWidth - 40));
      this.audioY = Math.max(0, Math.min(this.audioY, window.innerHeight - 40));

      e.preventDefault(); // 阻止默认行为
    },
    handleTouchAudioEnd() {
      this.isDraggingAudio = false;
      if (this.isClick) {
        const now = Date.now();
        if (now - this.lastAudioTapTime <= 300) {
          this.audioAfter();
          this.lastAudioTapTime = 0;
        } else {
          this.lastAudioTapTime = now;
        }
      }
      this.endRemove();
    },
     audioAfter(){
      if(localStorage.getItem("localAudioStute")=="1"){
          this.localAudioSet();
        }else{
        //   Dialog.confirm({
        //     title: "是否关闭录音？",
        //   }).then(() => {
        //     //this.goAiAudio();
        //     this.handleChange();
        //   });
         }
    },
      checkLocalAudioSet() {
      if(localStorage.getItem("localAudioStute")=="1"){
        // if(this.stateObject.recordingDeviceOnlineStatus != 1){
          document.getElementById("aiAudioIcon").style.display="flex";
       // }
      }else{
        //if(this.stateObject.recordingDeviceOnlineStatus != 1){
          document.getElementById("aiAudioIcon").style.display="none";
        //}
      }
    },
    localAudioSet() {
      let that=this;
      commonObj.localAudioSet(function (suc) {
        that.checkLocalAudioSet();
      });
    },
  },
};
</script>

<style>
@import "./style/common.css";
@import "./iconfont/iconfont.css";
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  @keyframes show {
    0% {
      transform: translateY(100px);
    }

    60% {
      transform: translateY(-80upx);
    }

    100% {
      transform: translateY(0px);
    }
  }
}
.router-view-c {
  position: absolute;
  transition: opacity 0.3s, transform 0.3s;
  width: 100%;
}

.forward-enter,
.back-leave-active {
  opacity: 0.5;
  transform: translateX(100%);
}

.forward-leave-active,
.back-enter {
  opacity: 0.5;
  transform: translateX(-100%);
}
</style>
<style scoped>
.ai_service {
  position: fixed;
  /* bottom: 10vh;
    right: 2px; */
  border-radius: 40px;
  width: 40px;
  height: 40px;
  background-color: #ff8f00;
  z-index: 2;
  display: flex;
  align-items: center;
  justify-content: center;
  /*touch-action: none;  禁用默认触摸行为 */
  /*transition: transform 0.2s;  添加平滑过渡效果 */
}
.ai_service_icon {
  font-size: 30px;
  color: white;
}
.ai-interview-recording {
  position: fixed;
  /* bottom: 10vh;
    right: 2px; */
  border-radius: 40px;
  width: 40px;
  height: 40px;
  background-color: #fff;
  z-index: 2;
  display: flex;
  align-items: center;
  justify-content: center;
}
.ai-interview-recording .iconfont {
  font-size: 32px;
  color: #1890ff;
}
</style>



// WEBPACK FOOTER //
// src/App.vue